
export default function Footer() {
  return (
    <footer className="bg-[#3F3F3F] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Logo e Descrição */}
          <div className="lg:col-span-2">
            <div className="flex items-center mb-4">
              <img 
                src="https://static.readdy.ai/image/50171caa7fe9961724fd6c723691a199/aa1f155aa5df557e2868a0945448c12d.png" 
                alt="P&P Engenharia e Arquitetura" 
                className="h-16 w-auto"
              />
            </div>
            <p className="text-gray-300 mb-6 max-w-md">
              Transformamos ideias em espaços de alto padrão, combinando técnica, estética e precisão em cada detalhe.
            </p>
            <div className="flex space-x-4">
              <a href="https://instagram.com/p_pengenhariaearquitetura" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-[#5C1A24] rounded-full flex items-center justify-center hover:bg-[#4A1520] transition-colors cursor-pointer">
                <i className="ri-instagram-line text-white"></i>
              </a>
              <a href="https://www.linkedin.com/company/p&p-engenharia-e-arquitetura/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-[#5C1A24] rounded-full flex items-center justify-center hover:bg-[#4A1520] transition-colors cursor-pointer">
                <i className="ri-linkedin-line text-white"></i>
              </a>
            </div>
          </div>

          {/* Contato */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contato</h3>
            <div className="space-y-3 text-gray-300">
              <div className="flex items-center">
                <i className="ri-phone-line mr-3 text-[#5C1A24]"></i>
                <span>(11) 98034-1891</span>
              </div>
              <div className="flex items-center">
                <i className="ri-mail-line mr-3 text-[#5C1A24]"></i>
                <span>pep.enarq@hotmail.com</span>
              </div>
              <div className="flex items-start">
                <i className="ri-map-pin-line mr-3 text-[#5C1A24] mt-1"></i>
                <span>R. João Geraldo, 197 - Vila Aricanduva<br />São Paulo - SP, 03515-040</span>
              </div>
            </div>
          </div>

          {/* Serviços */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Serviços</h3>
            <ul className="space-y-2 text-gray-300">
              <li><a href="#" className="hover:text-white transition-colors cursor-pointer">Arquitetura de Alto Padrão</a></li>
              <li><a href="#" className="hover:text-white transition-colors cursor-pointer">Engenharia Premium</a></li>
              <li><a href="#" className="hover:text-white transition-colors cursor-pointer">Regularização</a></li>
              <li><a href="#" className="hover:text-white transition-colors cursor-pointer">Gestão de Obras</a></li>
            </ul>
          </div>
        </div>

        {/* Mapa */}
        <div className="mt-12 mb-8">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3657.0234567!2d-46.5234567!3d-23.5234567!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94ce5c123456789%3A0x123456789abcdef!2sR.%20Jo%C3%A3o%20Geraldo%2C%20197%20-%20Vila%20Aricanduva%2C%20S%C3%A3o%20Paulo%20-%20SP%2C%2003515-040!5e0!3m2!1spt!2sbr!4v1234567890"
            width="100%"
            height="300"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            className="rounded-lg"
          ></iframe>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-600 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-white text-sm">
            © 2025 P&P Engenharia e Arquitetura. Todos os direitos reservados.
          </p>
          <a 
            href="https://agencianor.com.br/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-white hover:text-gray-300 text-sm transition-colors cursor-pointer mt-4 md:mt-0 flex items-center"
          >
            <img 
              src="https://static.readdy.ai/image/50171caa7fe9961724fd6c723691a199/ab3abc3303ff5c5052ba2788ab1e2c52.png" 
              alt="Agência NOR Logo" 
              className="h-4 w-auto mr-2"
            />
            Agência NOR
          </a>
        </div>
      </div>
    </footer>
  );
}
